import { CheckboxStandardSettings } from 'apps/studio/components/settings/fields/Checkbox/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Checkbox/advanced'

export const CheckboxSettings = [
  FieldSettingsPanel(CheckboxStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
